const defaultSitemapObject = {
  Items: [
    {
      ItemType: 2,
      Section: {
        SectionName: "Communications",
        Icon: "envelope",
        SectionItems: [
          {
            ItemType: 1,
            SubSection: null,
            Page: {
              PageType: 1,
              ListName: "Email Communications",
              RecordName: "Email Communication",
              Id: "g4c_communication",
              WorkspaceId: null,
              ReportId: null,
              URL: null,
              PageId: null,
              OpenInNewTab: false,
            },
          },
          {
            ItemType: 1,
            SubSection: null,
            Page: {
              PageType: 1,
              ListName: "Audiences",
              RecordName: "Audience",
              Id: "g4c_communicationaudience",
              WorkspaceId: null,
              ReportId: null,
              URL: null,
              PageId: null,
              OpenInNewTab: false,
            },
          },
          {
            ItemType: 1,
            SubSection: null,
            Page: {
              PageType: 1,
              ListName: "Reporting Campaigns",
              RecordName: "Reporting Campaign",
              Id: "campaign",
              WorkspaceId: null,
              ReportId: null,
              URL: null,
              PageId: null,
              OpenInNewTab: false,
            },
          },
          {
            ItemType: 1,
            SubSection: null,
            Page: {
              PageType: 1,
              ListName: "A/B Tests",
              RecordName: "A/B Test",
              Id: "g4c_abtest",
              WorkspaceId: null,
              ReportId: null,
              URL: null,
              PageId: null,
              OpenInNewTab: false,
            },
          },
          {
            ItemType: 1,
            SubSection: null,
            Page: {
              PageType: 1,
              ListName: "Communication Activities",
              RecordName: "Communication Activity",
              Id: "g4c_communicationactivity",
              WorkspaceId: null,
              ReportId: null,
              URL: null,
              PageId: null,
              OpenInNewTab: false,
            },
          },
          {
            ItemType: 1,
            SubSection: null,
            Page: {
              PageType: 1,
              ListName: null,
              RecordName: "Blacklist and Mail Exclusion",
              Id: "blacklist_and_mail_exclusion",
              WorkspaceId: null,
              ReportId: null,
              URL: null,
              PageId: null,
              OpenInNewTab: false,
            },
          },
          {
            ItemType: 1,
            SubSection: null,
            Page: {
              PageType: 1,
              ListName: "Email Preference Groups",
              RecordName: "Email Preference Group",
              Id: "g4c_subscriptiongroup",
              WorkspaceId: null,
              ReportId: null,
              URL: null,
              PageId: null,
              OpenInNewTab: false,
            },
          },
        ],
      },
      Page: null,
    },
    {
      ItemType: 2,
      Section: {
        SectionName: "Data Maintenance",
        Icon: "database",
        SectionItems: [
          {
            ItemType: 1,
            SubSection: null,
            Page: {
              PageType: 1,
              ListName: "Accounts",
              RecordName: "Account",
              Id: "account",
              WorkspaceId: null,
              ReportId: null,
              URL: null,
              PageId: null,
              OpenInNewTab: false,
            },
          },
          {
            ItemType: 1,
            SubSection: null,
            Page: {
              PageType: 1,
              ListName: "Contacts",
              RecordName: "Contacts",
              Id: "contact",
              WorkspaceId: null,
              ReportId: null,
              URL: null,
              PageId: null,
              OpenInNewTab: false,
            },
          },
          {
            ItemType: 1,
            SubSection: null,
            Page: {
              PageType: 1,
              ListName: "Static Marketing Lists",
              RecordName: "Static Marketing List",
              Id: "list",
              WorkspaceId: null,
              ReportId: null,
              URL: null,
              PageId: null,
              OpenInNewTab: false,
            },
          },
        ],
      },
      Page: null,
    },
  ],
};

export { defaultSitemapObject };
